import { render, staticRenderFns } from "./CompanyBrand.vue?vue&type=template&id=867c178e&scoped=true"
import script from "./CompanyBrand.vue?vue&type=script&lang=ts"
export * from "./CompanyBrand.vue?vue&type=script&lang=ts"
import style0 from "./CompanyBrand.vue?vue&type=style&index=0&id=867c178e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "867c178e",
  null
  
)

export default component.exports